import { useEffect, useState } from "react"
import { Button, TextField, Grid, Typography, InputLabel, FormControlLabel, Checkbox, MenuItem, LinearProgress,Link, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router";
import progs from '../resources/prog'
import config from '../config.json';
import { apiRequest } from '../functions/apiRequest';
import { useLocation } from 'react-router-dom';
import CustomAliceCarousel from "../customComponents/customAliceCarousel";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const gridStyle = {
    border: '1px solid #ccc', // Grey outline
    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.5)', // Shadow
    padding: '16px', // Add padding for spacing    
    cursor: 'pointer',
};

const noEmployeeDrives = ['3']
const PhonePeDonate = (props) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const driveId = queryParams.get('drive_id');
    const isCouponDrive = queryParams.get('coupon_drive') === 'true';
    const isFestiveDrive = queryParams.get('festive_drive') === 'true';
    const transactionId = queryParams.get('transactionId');
    const company = decodeURIComponent(queryParams.get('company'));
    const [isLoading, setisLoading] = useState(true)
    const [others, setOthers] = useState(true)
    const [programs, setPrograms] = useState([])
    const [ProgramEvents, setProgramEvents] = useState([])
    const [val, setVal] = useState(false)
    const [state, setState] = useState(false)
    const [selectedIdx, setSelectedIdx] = useState(-1);
    const [category, setCategory] = useState('')
    const [isCircularProgress, setCircularProgress] = useState(false);
    const navigate = useNavigate()

    const [error, setError] = useState(false)
    const stringifiedUser = localStorage.getItem('user');
    const user = JSON.parse(stringifiedUser);

    const initialFormData = Object.freeze({
        amount: '',
        email_id: '',
        name: '',
        program: '',
        event: '',
        number: '',
        pan: '',
        address: '',
    });
    const [formData, updateFormData] = useState(initialFormData);


    const handleSelect = (categoryName) => {
        let idx = programs.findIndex(category => { return category.name === categoryName })
        setSelectedIdx(idx);
        updateFormData({
            ...formData,
            // Trimming any whitespace
            note: categoryName,
        });
    }
    const handleChange = (e) => {
        updateFormData({
            ...formData,
            // Trimming any whitespace
            [e.target.name]: e.target.value,
        });
    };

    async function changeProgram(e) {
        try {
            
            if (e.target.value !== 0 && e.target.value.ProgramId) {
                setCircularProgress(true);
                const data = await apiRequest('get', null, `/program/events/view?program_id=${e.target.value.ProgramId}`);
                setProgramEvents(data[0].Event)
                if (data[0].Event.length > 0 && !isCouponDrive) {
                    setOthers(false)
                }
                setCircularProgress(false);
            } else {
                setOthers(true)
            }            
        } catch (e) {

        }
    }

    const handleChangee = (e) => {
        setVal(!val)
        setState(!state)
    }

    const fetchPrograms = async () => {
        try {
            let allPrograms = await apiRequest('GET', null, '/programs/list/view');
            console.log(process.env.REACT_APP_PROGRAM_DONATION_LIST);
            let programIdsToDisplay = process.env.REACT_APP_PROGRAM_DONATION_LIST.split(',').map(id => id.trim());
            console.log("IDs to display:", programIdsToDisplay);
            let programsToDisplay = allPrograms.filter(program => { 
                return programIdsToDisplay.includes(String(program.ProgramId)) 
            });
            console.log("Filtered programs:", programsToDisplay);
            programsToDisplay.push({ ProgramName: "Others", ProgramId: 0 });
            setPrograms(programsToDisplay);
        } catch (err) {
            return [];
        }
    }

    const fetchCouponPrograms = async () => {
        try {
            const data = await apiRequest('get', null, `/coupon/details/${driveId}`);
            setPrograms(data.categories)
        } catch (err) {
            return []
        }
    }

    const handleSubmit = async () => {
        let body = {
            amount: formData.amount
        }
        const response = await apiRequest('post', JSON.stringify(body), '/phonepe/donate');
        formData.transactionId = response.transactionId;
        localStorage.setItem('phonepeTransaction', JSON.stringify(formData));
        window.location.href = response.phonepeUrl;
    }

    const getTransactionStatus = async () => {
        let body = {
            merchantTransactionId: transactionId
        }
        let transactionForm = localStorage.getItem('phonepeTransaction');
        transactionForm = JSON.parse(transactionForm);
        const response = await apiRequest('post', JSON.stringify(body), '/phonepe/transaction-status');
        if (transactionForm.transactionId === transactionId) {
            if (response.state === 'COMPLETED') {
                const data = {
                    orderCreationId: transactionId,
                    razorpayPaymentId: transactionId,
                    razorpayOrderId: transactionId,
                    razorpaySignature: transactionId,
                };
                navigate({
                    pathname: 'thankyou',
                    state: {
                        detail: data,
                        form: transactionForm,
                        name: user ? (user.first_name + ' ' + user.last_name) : '',
                        email: user ? user.email_id : '',
                        contact: user ? user.mobile_number : '',
                        user_id: user ? user.id : '',
                        status: response
                    }
                })
            } else if (response.state !== 'FAILED') {
                toast.warn('Your Payment is processing, please refresh the page to view the status')
            } else {
                toast.error('Your payment has failed. Any amount debited will be refunded. Please contact our support for any assistance')
            }
        }
        setisLoading(false);
    }

    useEffect(() => {
        if (!transactionId) {
            if (isCouponDrive || isFestiveDrive) {
                fetchCouponPrograms();
                setCategory('Coupon Donation Drive')
            } else {
                fetchPrograms();
            }
            setisLoading(false);
        } else {
            if (transactionId) {
                getTransactionStatus();
            }
        }
        // eslint-disable-next-line
    }, [])



    if (!isLoading && !transactionId) {
        return (
            <div style={{ justifyContent: 'center', display: 'flex' }}>
                <Grid container spacing={1} justifyContent="center" style={{ fontFamily: 'Raleway', textAlign: 'center', paddingTop: '0.5vw',paddingLeft:"4vw",paddingRight:"4vw" }}>
                    <Grid item xs={12} md={3} hidden={isFestiveDrive}></Grid>
                    <Grid item xs={12} md={6} lg={10}>
                        <Grid container spacing={1} justifyContent="center" style={{ fontFamily: 'Raleway', textAlign: 'center' }}>
                            <Grid item xs={12}>
                                <Typography style={{ fontSize: 30, fontFamily: 'Raleway' }}>
                                    {!isFestiveDrive && "Donate generously to help us build India's largest time bank"}
                                    {isFestiveDrive && "Skip the sweets, make a difference – donate for a brighter Diwali!"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography style={{ fontSize: 30, fontFamily: 'Raleway' }}>Your donation qualifies for 80G tax rebate </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} hidden={!isFestiveDrive}>
                        <Grid container justifyContent='center' >
                            {programs && programs.map((category, idx) => <Grid item xs={12} md={3} key={category.name} style={{ ...gridStyle, backgroundColor: idx === selectedIdx ? 'rgba(0, 255, 0, 0.4)' : 'transparent' }} onClick={() => { handleSelect(category.name) }}>
                                {category.images && <CustomAliceCarousel images={category.images} autoPlayInterval={2000} />}
                                <Typography style={{ fontSize: '20pt', textAlign: 'center', fontFamily: 'Raleway' }}>
                                    {category.name}
                                </Typography>
                            </Grid>)}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3} hidden={isFestiveDrive}></Grid>
                    <Grid item xs={12} md={6} lg={10}>
                        <Grid container spacing={2} justifyContent="center" style={{ fontFamily: 'Raleway', textAlign: 'center'}}>
                            <Grid item xs={12} md={6} lg={6}>
                                <Grid container justifyContent="center" spacing={2}>
                                    <Grid item xs={12} md={12} hidden={isFestiveDrive}>
                                        <TextField
                                            select
                                            label='WHICH CATERGORY ARE YOU DONATING FOR?'
                                            fullWidth
                                            placeholder='Who is your donation for?'
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={category ? category : ''}
                                            onChange={(e) => { handleChange(e); setCategory(e.target.value) }}
                                            id='category'
                                            name='category'
                                        >
                                            {progs && progs.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>

                                            ))}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={12} md={12} hidden={isFestiveDrive}>
                                        <TextField
                                            select
                                            label='CHOOSE YOUR PROGRAM'
                                            fullWidth
                                            placeholder='Who is your donation for?'
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            id='program'
                                            name='program'
                                            defaultValue={''}
                                            onChange={handleChange}
                                            onClick={changeProgram}
                                        >
                                            {programs && programs.map((option) => (
                                                <MenuItem key={option.ProgramId} value={option}  >
                                                    {option.ProgramName}
                                                </MenuItem>
                                            ))
                                            }
                                        </TextField>
                                    </Grid>
                                    {isCircularProgress ? (
                                        <div
                                        style={{
                                            textAlign: "center",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "40vh",
                                            margin: "auto",
                                        }}
                                        >
                                        <CircularProgress />
                                        </div>
                                    ) : (
                                        <Grid item xs={12} md={12} hidden={others}>
                                        <TextField
                                            select
                                            label='CHOOSE YOUR EVENT'
                                            fullWidth
                                            placeholder='Who is your donation for?'
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            id='event'
                                            name='event'
                                            defaultValue={''}
                                            onChange={handleChange}
                                        >
                                            {ProgramEvents && ProgramEvents.map((option2) => (
                                                <MenuItem key={option2.EventID} value={option2}>
                                                    {option2.Title}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    )}
                                    <Grid item xs={12} md={12} hidden={isFestiveDrive}>
                                        <TextField
                                            label='Note'
                                            fullWidth
                                            placeholder='Note'
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            id='note'
                                            name='note'
                                            onChange={handleChange}
                                        >

                                        </TextField>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={7} style={{ marginTop: 15,marginBottom: 15 }}>
                                <InputLabel style={{ textAlign: 'left' }}>Amount (in ₹)</InputLabel>
                                <TextField
                                    variant="outlined"
                                    required
                                    size='small'
                                    fullWidth
                                    style={{ height: 40 }}
                                    id="amount"
                                    name="amount"
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} hidden={isFestiveDrive || (!isCouponDrive || noEmployeeDrives.includes(driveId))}>
                                <Typography style={{ textAlign: 'center' }}>Your donation {formData.amount !== '' ? `of ₹${formData.amount}` : ''} will be matched by {company}! doubling your impact{formData.amount !== '' ? ` and making your effective donation ₹${formData.amount * 2}!` : '!'}</Typography>
                            </Grid>
                            {error ?

                                <Grid item xs={12}>
                                    Please fill out the amount field
                                </Grid>

                                : ''
                            }
                            <Grid item xs={12} md={12} lg={7}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name='checked'
                                            defaultChecked={state}
                                            onChange={handleChangee}
                                            style={{ fontFamily: 'Raleway', color: config[process.env.REACT_APP_HOST_NAME].css.buttonColor }}
                                        />
                                    }
                                    label={<Typography>By clicking proceed, you agree to our {' '}
                                    <Link href='/terms' target='_blank' rel='noopener noreferrer'>Terms and conditions, </Link>{' '}
                                    <Link href='/refund-policy' target='_blank' rel='noopener noreferrer'>Fees and Refund Policy</Link>{' '}
                                    and that you have read and accepted our {' '}
                                    <Link href='/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy Policy</Link>.
                                     </Typography>}
                                />
                            </Grid>


                            <Grid item xs={12}>
                                <Grid item xs={12} style={{ padding: '10px' }}>
                                    Please note that upon clicking pay you will be redirected to PhonePe to complete your payment.
                                </Grid>
                                {val ?
                                    <Button onClick={() => {
                                        if (formData.amount !== '') {
                                            handleSubmit()
                                        } else {
                                            setError(true)
                                        }
                                    }} style={{ backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.websiteColor, color: 'white' }}>Payn</Button> : ''}
                            </Grid>
                            <br></br>
                        </Grid>
                    </Grid>
                </Grid>
            </div> 
        )
    } else if (isLoading) {
            return (
            <div style={{ marginTop: 20, textAlign: 'center' }}>
                <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
                <LinearProgress />

            </div>
        )
        

        
    }

}

export default PhonePeDonate 